import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { useNavigate } from 'react-router-dom';
import { User, Mail, Phone, FileText, Shield, LogOut } from 'lucide-react';
import { PushNotificationSettings } from '../components/lifelink/PushNotificationPrompt';
import { getCountryByCode } from '../utils/countries';

export default function ProfilePage() {
  const { user, logout } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();

  if (!user || user === false) {
    navigate('/login');
    return null;
  }

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const fields = [
    { icon: User, label: t('nome'), value: `${user.nome || ''} ${user.cognome || ''}` },
    { icon: Mail, label: t('email'), value: user.email },
    { icon: Phone, label: t('telefono'), value: user.telefono || '-' },
    ...(user.numero_passaporto
      ? [{
          icon: FileText,
          label: 'Passaporto',
          value: (() => {
            const c = getCountryByCode(user.paese_passaporto);
            return c ? `${c.flag} ${c.name} · ${user.numero_passaporto}` : user.numero_passaporto;
          })(),
        }]
      : user.codice_iss
        ? [{ icon: FileText, label: 'Codice ISS (San Marino)', value: user.codice_iss }]
        : [{ icon: FileText, label: t('codice_fiscale'), value: user.codice_fiscale || '-' }]),
    { icon: FileText, label: t('documento_identita'), value: user.documento_identita || '-' },
    { icon: Shield, label: 'Ruolo', value: user.role?.toUpperCase() || 'CIVILE' },
  ];

  return (
    <div className="min-h-screen bg-[#E8F4FD] pt-20 pb-8" data-testid="profile-page">
      <div className="max-w-lg mx-auto px-4">
        <div className="border border-[#B8D4E8] bg-white p-6">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-16 h-16 bg-[#FF3B30] flex items-center justify-center text-[#0D1B2A] font-black text-2xl font-['Barlow_Condensed']">
              {(user.nome?.[0] || 'U').toUpperCase()}
            </div>
            <div>
              <h1 className="font-['Barlow_Condensed'] text-xl font-bold uppercase tracking-tight text-[#0D1B2A]">
                {user.nome} {user.cognome}
              </h1>
              <span className="text-xs text-[#6B8AB5] uppercase tracking-widest">{user.role}</span>
            </div>
          </div>

          <div className="space-y-4">
            {fields.map(({ icon: Icon, label, value }) => (
              <div key={label} className="flex items-center gap-3 border-b border-[#B8D4E8] pb-3">
                <Icon size={16} className="text-[#6B8AB5]" />
                <div>
                  <span className="block text-[10px] uppercase tracking-widest text-[#6B8AB5]">{label}</span>
                  <span className="text-sm text-[#0D1B2A]">{value}</span>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-6">
            <PushNotificationSettings />
          </div>

          <button
            onClick={handleLogout}
            className="mt-6 w-full flex items-center justify-center gap-2 px-6 py-3 border border-[#FF3B30] text-[#FF3B30] font-bold uppercase tracking-widest hover:bg-[#FF3B30] hover:text-[#0D1B2A] transition-all text-sm"
            data-testid="profile-logout-btn"
          >
            <LogOut size={16} />
            {t('esci')}
          </button>
        </div>
      </div>
    </div>
  );
}
